export default "__VITE_ASSET__Cg86jTsj__"